import { render, staticRenderFns } from "./BaseRqPostulantes.vue?vue&type=template&id=624cda5c&scoped=true&"
import script from "./BaseRqPostulantes.vue?vue&type=script&lang=js&"
export * from "./BaseRqPostulantes.vue?vue&type=script&lang=js&"
import style0 from "./BaseRqPostulantes.vue?vue&type=style&index=0&id=624cda5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624cda5c",
  null
  
)

export default component.exports